import { useMemo } from 'react';

import { useFirebaseValue } from './useFirebaseValue';
import { queryKeys } from '@/lib/queryKeys';
import { STALE_TIMES } from '@/lib/queryClient';
import { playersMapSchema, type Player } from '@/lib/schemas';

/* =====================================================================
   usePlayers — suscripción live a /players.
   staleTime = REALTIME (0) porque los puntajes cambian durante el evento.

   Devuelve `list` con cada jugador anotado con su id (el push key de RTDB),
   listo para tablas y exportación CSV.
===================================================================== */

export interface PlayerWithId extends Player {
  id: string;
}

export function usePlayers() {
  const q = useFirebaseValue(queryKeys.players.all, 'players', playersMapSchema, {
    staleTime: STALE_TIMES.REALTIME,
  });
  const list = useMemo<PlayerWithId[]>(() => {
    if (!q.data) return [];
    return Object.entries(q.data).map(([id, p]) => ({ ...p, id }));
  }, [q.data]);
  return { ...q, list };
}
